import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Container, Spinner } from "@/components/shared";
import { FicheContent, ShareBar } from "@/components/RightsFiche";
import { ArrowLeft } from "lucide-react";

export default function RightDetail() {
  const { slug } = useParams();
  const [sheet, setSheet] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setSheet(null); setError(false);
    api.get(`/rights/${slug}`).then(({ data }) => setSheet(data)).catch(() => setError(true));
  }, [slug]);

  if (error) return (
    <Container>
      <Link to="/rights" className="text-white/50 hover:text-gold text-sm inline-flex items-center gap-2 mb-6"><ArrowLeft size={16} /> Retour</Link>
      <p className="text-white/60">Fiche introuvable.</p>
    </Container>
  );
  if (!sheet) return <Container><Spinner label="Chargement de la fiche..." /></Container>;

  return (
    <Container>
      <Link to="/rights" data-testid="rights-back" className="text-white/50 hover:text-gold text-sm inline-flex items-center gap-2 mb-6"><ArrowLeft size={16} /> Toutes les fiches</Link>
      <div className="mb-5 fade-up">
        <p className="text-gold text-xs uppercase tracking-[0.2em] mb-3">{sheet.category}</p>
        <h1 className="font-display text-3xl md:text-4xl tracking-tight font-light" data-testid="rights-title">{sheet.title}</h1>
        <p className="text-white/70 mt-3 max-w-2xl leading-relaxed">{sheet.summary}</p>
      </div>
      <div className="mb-6"><ShareBar slug={sheet.slug} title={sheet.title} summary={sheet.summary} /></div>
      <FicheContent sheet={sheet} />
    </Container>
  );
}
